import { PLAYBACKS } from '@hotjar/webapp/constants/routes';
import { useDismiss } from '@hotjar/webapp/hooks/useDismiss';
import { useRecentSurveys } from '@hotjar/webapp/hooks/useRecentSurveys';
import { useRecordingsStatefulCounter } from '@hotjar/webapp/recordings/useStatefulPlaybackTracker';
import { getRouteConfigByPath } from '@hotjar/webapp/utils/routing';
import { useLocation } from 'react-router-dom';
import { APP_STATE_NAMESPACE } from '../FloatingSuggestions/constants';

interface UseFeedbackPopup {
  isEnabled: boolean;
  dismiss: () => void;
}

export const useFeedbackPopup = (): UseFeedbackPopup => {
  const location = useLocation();
  const inRecordingsListPage = [PLAYBACKS.LIST.name].includes(
    getRouteConfigByPath(location.pathname)?.name || '',
  );
  const { isDismissed, dismiss } = useDismiss(APP_STATE_NAMESPACE, 'feedback');
  const { counterValue } = useRecordingsStatefulCounter();
  const { data: surveys, isLoading, isError } = useRecentSurveys();
  const enabledSurveys = surveys?.filter(({ enabled }) => enabled);
  const noActiveSurveys = isError || !enabledSurveys || enabledSurveys.length === 0;
  const isEnabled =
    !isDismissed &&
    inRecordingsListPage &&
    Number(counterValue) >= 2 &&
    !isLoading &&
    noActiveSurveys;

  return { isEnabled, dismiss };
};
